import { Button, Col, Container, Row } from "react-bootstrap";
import Logo from "../assets/Logo.png";
import { NavLink } from "react-router-dom";
import { FaRegCopyright } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";


const Footer = () => {
  const location = useLocation();
  const buttonStyle = {
    // bottom: "10px",
    // right: "10px",
    border: "none",
    background: "transparent",
    color: "white",
    // textDecoration: "underline",
    // marginRight: "15px",
  };

  const handleHomeClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (location.hash === "#home") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);

  return (
    <Container fluid className="bg-dark p-5 text-white text-center">
      <Row xs={1} md={2} lg={4}>
        <Col className="mt-3">
          <span>
            <h4>IDM 360 Analytics</h4>
          </span>
          <p>
            Delivering IT security excellence with innovative solutions that Protect, Empower, and Drive Growth for Industries worldwide.
          </p>
        </Col>
        <Col className="mt-3">
          <span>
            <h5>Quick Links</h5>
          </span>
          <p style={{padding:'0',margin:'0'}}>
            <Button as={NavLink} to={"/"} onClick={handleHomeClick} style={buttonStyle}>Home</Button>
          </p>
          <p style={{padding:'0',margin:'0'}}>
            <Button as={NavLink} to={"/contact"} style={buttonStyle}>Contact</Button>
          </p>
        </Col>
        <Col className="mt-5">
          <span>
            <h5>Contact</h5>
          </span>
          <Button style={buttonStyle} as={NavLink} to={"/contact"} >info@idm360analytics.com</Button>
        </Col>
        <Col>
          <img
            src={Logo}
            alt="Logo"
            style={{
              height: "6rem",
              marginTop: "30px",
            }}
          />
        </Col>
      </Row>

      <hr />

      <h3>We Provide best Security</h3>
      <p>
      <FaRegCopyright /> 2025 - <b>IDM 360 Analytics</b>
      </p>
      <p>By using this site, you agree to comply with and be bound by the Universal Terms of Service.</p>
    </Container>
  );
};

export default Footer;
